// Holds the short-lived post-registration MFA setup token (returned by
// POST /users/complete-registration, used only by Authentication.js to call
// generate-mfa/verify-mfa before an auth cookie exists) in a module-level JS
// variable - never in localStorage/sessionStorage, and, unlike
// navigate(path, { state }), never in window.history.state either.
// react-router stores navigate() state on the History API state object,
// which browsers persist across a full page reload on the same entry and
// which is readable via plain window.history.state by any JS on the page,
// including an XSS payload - so it doesn't actually give the "memory-only"
// guarantee it looks like it does. A module-level variable does: a reload
// re-evaluates this module from scratch, so the token is gone the moment
// the tab reloads, and there is no browser-exposed API that can read it.
let setupToken = null;

export const setSetupToken = (token) => {
    setupToken = token;
};

export const getSetupToken = () => setupToken;

export const clearSetupToken = () => {
    setupToken = null;
};
